// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jQe8q","title":"styles_title__ShiSx","terms":"styles_terms__mW9M1"};